import types from '../mutation-types';
import AgentNotesAPI from '../../api/agentNotes';
import camelcaseKeys from 'camelcase-keys';

export const state = {
  records: {},
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getAllNotesByAgentId: _state => agentId => {
    const records = _state.records[agentId] || [];
    const agentNotes = records.sort((r1, r2) => r2.id - r1.id);
    return camelcaseKeys(agentNotes);
  },
};

export const actions = {
  async get({ commit }, { agentId }) {
    commit(types.SET_AGENT_NOTES_UI_FLAG, { isFetching: true });
    try {
      const { data } = await AgentNotesAPI.get(agentId);
      commit(types.SET_AGENT_NOTES, { agentId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AGENT_NOTES_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, { agentId, content }) {
    commit(types.SET_AGENT_NOTES_UI_FLAG, { isCreating: true });
    try {
      const { data } = await AgentNotesAPI.create(agentId, content);
      commit(types.ADD_AGENT_NOTE, { agentId, data });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AGENT_NOTES_UI_FLAG, { isCreating: false });
    }
  },

  async delete({ commit }, { noteId, agentId }) {
    commit(types.SET_AGENT_NOTES_UI_FLAG, { isDeleting: true });
    try {
      await AgentNotesAPI.delete(agentId, noteId);
      commit(types.DELETE_AGENT_NOTE, { agentId, noteId });
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_AGENT_NOTES_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_AGENT_NOTES_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_AGENT_NOTES]($state, { data, agentId }) {
    $state.records = {
      ...$state.records,
      [agentId]: data,
    };
  },
  [types.ADD_AGENT_NOTE]($state, { data, agentId }) {
    const agentNotes = $state.records[agentId] || [];
    $state.records[agentId] = [...agentNotes, data];
  },
  [types.DELETE_AGENT_NOTE]($state, { noteId, agentId }) {
    const agentNotes = $state.records[agentId];
    const withoutDeletedNote = agentNotes.filter(note => note.id !== noteId);
    $state.records[agentId] = [...withoutDeletedNote];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
